import { useTranslation } from "react-i18next";
import { FaPhoneAlt } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoMailOutline } from "react-icons/io5";
import { API_URL } from "../../utils/constants";

function BannerDynamicButton({ id, type, url }) {
  const { t } = useTranslation();

  const generateColor = () => {
    if(type === 'whatsapp') return 'success';
    else return 'dark';
  };

  const generateIcon = () => {
    if(type === 'whatsapp') return <IoLogoWhatsapp size={20} />;
    else if(type === 'call') return <FaPhoneAlt size={20} />;
    else if(type === 'email') return <IoMailOutline size={20} />;
    else if(type === 'website') return <FiExternalLink size={20} />;
    else return null;
  };

  const generateText = () => {
    if(type === 'whatsapp') return t('banner.whatsapp');
    else if(type === 'call') return t('banner.call');
    else if(type === 'email') return t('banner.email');
    else if(type === 'website') return t('banner.website');
    else return null;
  };

  const handleClick = () => {
    fetch(API_URL+'/banners/'+id+'/increment-link-clicks', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        url_type: type
      })
    });
  }

  return(
    <a href={url} className={`btn btn-${generateColor()} btn-lg flex-grow-1`} target="_blank" onClick={handleClick}>
      {generateIcon()} {generateText()}
    </a>
  );
}

export default BannerDynamicButton;